import * as React from "react";
import { Card, CardContent } from "@/components/ui/card";
export default function CartContent() {
  return <section id="cart-content" className="bg-background py-16 md:py-24 min-h-[60vh]">
      <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-primary tracking-tight mb-4">
            Il tuo Carrello
          </h1>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Rivedi i prodotti selezionati prima di procedere al checkout.
          </p>
        </div>

        <Card className="rounded-xl shadow-sm border border-border/40 bg-card overflow-hidden">
          <CardContent className="p-6 md:p-12">
            {}
            <div className="w-full">
              [woocommerce_cart]
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}